import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import Config from '../../config';

/**
 * Skips the SSO handoff in USCR environments because wordpress 404's when provided with ?s=sso-token.
 */
export default function skipSsoForUscr(to: RouteLocationNormalized,
                                       from: RouteLocationNormalized,
                                       next: NavigationGuardNext
)                                     : void
{
    if (Config.IS_USCR)
    {
        const targetKey = to.meta.ssoTargetKey as keyof typeof Config;
        window.location.href = Config[targetKey] as string;
        return;
    }

    return next();
}
